import { CustomerService } from "@/services/api/customer.service";
import { basePagesMutations } from "@/store/base-pages";

const state = {
  items: [],
  meta: {
    total: 0,
  },
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    ...basePagesMutations,
  },

  actions: {
    removeItem({ commit, rootState }, item) {
      return CustomerService.removeReciept(rootState.customer.id, item.id).then(response => {
        if (response.success) {
          commit("REMOVE_ITEM", item);
        }

        return response;
      });
    },
  },
};
